import React from 'react'

function ChevronDown() {
  return (
    <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.3999 5.5L0.0697742 0.250001L8.73003 0.25L4.3999 5.5Z" fill="currentColor" />
    </svg>
  )
}

export default ChevronDown